<div class="db-main-header"
     [ngClass]="{'db-hidden': (user?.oneProductOrBundleClient && neverWebsiteCreated && _routeData?.pageId === 'add-website'
     || (currentWorkspace?.status === 'invited' && !user?.hostingTrialExpired))}">
  <div class="db-main-header__content" [ngClass]="{'db-add-website' : conditionalPages}">
    <ng-container>
      <a class="db-main-header__sidebar-toggle" (click)="toggleLeftSidebar()" *ngIf="isMobile">
        <i class="db-icon db-icon-ds-burger"></i>
      </a>


      <db-workspace-popup *ngIf="checkPageAndWorkspace && !isTrialExpired && !userSubscription?.platformPaidClient && !userSubscription?.trialClient"></db-workspace-popup>

      <a class="db-upgrade-to-pro-wrap" [ngClass]="{'inactive': _routeData?.pageId === 'upgrade-plan'}"
         *ngIf="demoUser && !isMobile && !campaignInfo"
         (click)="showCheckoutDialog('Unlock all features')">
        <i class="db-icon db-icon-ds-diamond"></i>
        <div class="db-upgrade-to-texts">
          <span>Get Pro</span>
          <div>
            <span>Unlock all the features</span>
          </div>
        </div>
      </a>

      <ds-breadcrumbs *ngIf="!customContentElement
      && !userSubscription?.plan?.services?.ai_assistant
      && !(trialOrOptimizerTrial && conditionalPages) && !isMobile"></ds-breadcrumbs>
      <div #mainHeaderContentHost class="db-main-header__custom-content"
           [ngClass]="{'db-sign-up-for-step': conditionalPages && user?.workspaces.length === 1 && userSubscription?.trialClient, 'db-add-website' : _routeData?.pageId === 'add-website'}">
      </div>

      <button class="ds-label ds-label-m ds-hide-mobile mr15"
              type="button" [routerLink]="['/upgrade-plan']"
              *ngIf="userSubscription?.trialBoosterClient && !showPercentOffer">
        <span><i class="db-icon db-icon-ds-diamond"></i>{{ 'text_tryBoosterForFree' | dbText }}</span>
      </button>

      <db-percent-offer
        *ngIf="showPercentOffer && !isMobile && !inGrandSlamPage && !userSubscription?.cancelDate && !isWorkspaceStatusInvited && currentWorkspace?.roleId === clientRoles.OWNER"
        [endDate]="endDate"
        [demoUser]="demoUser"
        [blkOffer]="true"
        [oneWeekFreeExpired]="oneWeekFreeExpired"
        [oneWeekFreeNotExpired]="oneWeekFreeNotExpired"
        [paidNotExpired]="paidNotExpired"
        (onTimerEnd)="showPercentOffer = false"
        class="mr15"></db-percent-offer>

      <db-anniversary-offer *ngIf="showAnniversaryOffer"
                            class="mr15"
                            [daysLeft]="anniversaryLeftDays"
                            [hoursLeft]="anniversaryLeftHours"
                            [minutesLeft]="anniversaryLeftMinutes"
                            [endDate]="userLocalStorage?.anniversaryOfferBannerEndDate"
                            [startDate]="userLocalStorage?.anniversaryOfferBannerStartDate"
                            (onTimerEnd)="showAnniversaryOffer = false"></db-anniversary-offer>

      <!--      <button class="ds-label-black db-blk-offer ml20" [class.hover]="showBlkOfferTooltip" type="button" *ngIf="!isMobile &&
            (userSubscription?.trialClient || userSubscription?.freeBaseClient) && _routeData?.pageId !== 'upgrade-plan'"
                (click)="redirectPricingPage()"
                    (mouseenter)="onShowTooltip()"
                    (mouseleave)="onHideTooltip()">
              <span>{{'text_blkOfferTwentyFour' | dbText}}</span>
            </button>-->

      <!--     <div class="db-blk-offer-tooltip" *ngIf="showBlkOfferTooltip"   @fadeSlideInOut>
             <div class="db-blk-offer-tooltip__title">Black Friday special.</div>
             <p class="db-blk-offer-tooltip__discount">30% off</p>
             <p class="db-blk-offer-tooltip__first-payment">first payment</p>
           </div>-->

      <button class="ds-label-black db-blk-offer ml20" [class.hover]="showBlkOfferTooltip" type="button" *ngIf="!isMobile &&
      (userSubscription?.trialClient || userSubscription?.freeBaseClient) && _routeData?.pageId !== 'upgrade-plan' && campaignInfo"
              (click)="redirectPricingPage()"
              (mouseenter)="onShowTooltip()"
              (mouseleave)="onHideTooltip()">
        <ng-container *ngIf="campaignInfo?.couponPercent; else freeTrial">
          <span>Try Pro with {{ campaignInfo?.couponPercent }}% off</span>
        </ng-container>
        <ng-template #freeTrial>
          <span>Try Pro free for {{ campaignInfo?.couponDays == 30 ? '1 month' : campaignInfo?.couponDays + ' days' }}</span>
        </ng-template>

      </button>

      <div class="db-blk-offer-tooltip campaign" *ngIf="showBlkOfferTooltip" @fadeSlideInOut>
        <ng-container *ngIf="campaignInfo?.couponPercent; else freeTrial">
          <div class="db-blk-offer-tooltip__title">Try Pro free<br *ngIf="!!campaignInfo?.couponPercent"/>
            for {{ campaignInfo?.couponDays == 30 ? '1 month' : campaignInfo?.couponDays + ' days' }} +
          </div>
          <p class="db-blk-offer-tooltip__discount">{{ campaignInfo?.couponPercent }}% off</p>
          <p class="db-blk-offer-tooltip__first-payment">first payment</p>
        </ng-container>

        <ng-template #freeTrial>
          <div class="db-blk-offer-tooltip__title">Try Pro free for</div>
          <p
            class="db-blk-offer-tooltip__discount">{{ campaignInfo?.couponDays == 30 ? '1 month' : campaignInfo?.couponDays + ' days' }}</p>
        </ng-template>
      </div>
    </ng-container>
  </div>
</div>


